import api from "../api";


export const getAppSettings = async () => {
  return await api.get("/setting/store-setting/all");
}